import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeactivateProperty } from '../../../domain/model/properties/deactivateProperty';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { PropertyService } from '../../../domain/service/propertyService';

@Component({
  selector: 'app-deactivate-property',
  templateUrl: './deactivate-property.component.html',
  styleUrl: './deactivate-property.component.css'
})
export class DeactivatePropertyComponent {
  dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  data = inject(DIALOG_DATA);
  currentRentalPropertyId: number=0;
  cancelRequest = new FormGroup({
    option: new FormControl(0, [
      Validators.required
    ]),
    lastDate: new FormControl(null, [
      Validators.required
    ]),
    reason: new FormControl(''),
  });
  constructor(private readonly router: Router,private services: PropertyService, private fb: FormBuilder,private readonly route: ActivatedRoute){
    const id: string = this.route.snapshot.params['id'];
    this.currentRentalPropertyId = Number.parseInt(id)
  }
   

  deactivateProperty() :void {
    let model : DeactivateProperty = {
      option:this.cancelRequest.get('option')?.value??0,
      reason: this.cancelRequest.get('reason')?.value??'',
      id:this.data.id ,
      lastDate:this.cancelRequest.get('lastDate')?.value??''
    };

    this.services.deactivateProperty(model).subscribe({
      next: (response) => {
        this.router.navigate(['app/properties']);
        this.dialogRef.close();
      },
      error: (error) => {
      
      },
      complete :() =>{ 
        this.router.navigate(['app/properties']);
      }
    });
  }

}
